import { XClose } from '@recruit-robin/robin-theme/web-icons';
import { motion } from 'motion/react';

import { SerializedStyles } from '@emotion/react';
import { useStyles } from './CloseButton.styles';

export const CloseButton = ({
  onClose,
  size = 24,
  customCss,
}: {
  onClose: () => void;
  size?: number;
  customCss?: SerializedStyles;
}) => {
  const classes = useStyles({ size });

  return (
    <motion.div
      css={[classes.closeButton, customCss]}
      onClick={() => onClose()}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}>
      <XClose size={size} color={(c) => c.neutral.variant[70]} />
    </motion.div>
  );
};
